<template>
	<div class="scroll" @scroll="handleScroll">
    <div class="order_body" v-for="(item, index) in order_list" :key="index">
        <div class="order_body_d1" >
            <div class="order_body_d1_l" >
                <span style="color: #999;">订单号：</span>
                {{ item.OrderNo }}
            </div>
            <div class="order_body_d1_r">
                <el-button
                    plain
                    type="default"
                    size="small"
                    @click="orderDel(item.OrderNo)"
                >删除</el-button>
            </div>
        </div>
        <div class="order_body_d2" v-for="product in item.order_goods" :key="product.id">
            <img :src="imgUrl+product.ProductImg"/>
            <div class="order_body_d2_d1">
                <span class="order_body_d2_sp1">{{product.ProductName}}</span>
                <span class="order_body_d2_sp2">价格：￥{{product.Price}}</span>
            </div>
            <div class="order_body_d2_d3">×{{ product.Count }}</div>
        </div>
        <div class="order_body_d3">
            <span v-if="item.OrderState == 1">待付款</span>
      		<span v-if="item.OrderState == 2">待发货</span>
    		<span v-if="item.OrderState == 3">待收货</span>
    		<span v-if="item.OrderState == 4">已完成</span>
    		<span v-if="item.OrderState == 5">已取消</span>
            <span class="order_body_d3_sp2" v-if="item.OrderState == 1">价格：￥{{item.OrderQZPrice}}元</span>
        </div>
        <div class="order_body_d4">
            <el-button
                plain
                type="default"
                size="small"
                class="order_body_d4_b"
                @click="tobuy(item.OrderNo)"
            >订单详情</el-button>
            <el-button
				v-if="item.OrderState != 5"
                plain
                type="default"
                size="small"
                class="order_body_d4_b"
                @click="CancelOrder(item.OrderNo)"
            >取消订单</el-button>
            <el-button 
				v-if="item.OrderState == 1"
                type="danger"
                size="small"
                class="order_body_d4_b"
				@click="tobuy(item.OrderNo)"
            >继续支付</el-button>
			<el-button 
				v-if="item.OrderState == 3 || item.OrderState == 2"
                type="danger"
                size="small"
                class="order_body_d4_b"
				@click="ConfirmOrders(item.OrderNo)"
            >确认收货</el-button>
        </div>
		<div class='loading' v-if="isLoading">Loading...</div>
		<div class='loading' v-if="!hasMoreData">已加载所有数据</div>
    </div>
</div>
</template>

<script>
import { VUE_APP_IMG_URL } from "@/config";
import { mapGetters } from "vuex"
export default {
		data() {
			return {
				imgUrl: "",
				OrderNo:'',
				activeName: '0',
				state:'0',
				order_list:[],
				cont:'',
				page:1,
				isLoading:false,
				hasMoreData:true,
			}
		},
		computed: {
            ...mapGetters(["device"])
		},
		watch: {

		},
		created: function() {
			this.imgUrl = VUE_APP_IMG_URL;
		},
		mounted: function() {
			window.addEventListener('scroll', this.handleScroll);
			this.get_Order();
			// this.getMyOrderState();
		},
		methods: {
			handleScroll() {
  			  if (!this.isLoading && this.hasMoreData) {
    			  const container = document.querySelector('.scroll');
    			  const scrollHeight = container.scrollHeight;
    			  const offsetHeight = container.offsetHeight;
    			  const scrollTop = container.scrollTop;
    			  if (scrollHeight - scrollTop - offsetHeight <= 50) {
    			    this.loadMoreData();
    			  }
    			}
  			},
  			 loadMoreData() {
  			  this.isLoading = true;
  			  setTimeout(async () => {
  			    let res =  await this.$post("get_Order",{state: this.state ,page:this.page}) 
				const newData = res.data.ResultData;
				console.log(newData,'newData');
  			    this.order_list = [...this.order_list, ...newData];
				console.log(this.order_list,'this.order_list');
  			    this.page += 1;
				if(newData.length<10){
					this.hasMoreData = false;
				}
  			    this.isLoading = false; 
  			  }, 1000); 
  			},
			
			handleClick(tab){
    			const tabIndex = tab.name;
				this.state = tabIndex;
				this.hasMoreData = true;
				// this.order_list=[];
				this.get_Order();
			},
			async orderDel(e) {
				await this.$confirm("你是否要删除该条订单数据?", "提示", {
        			width: "300px",
        			confirmButtonText: "确定",
        			cancelButtonText: "取消",
        			type: "warning",
      			});
    		    this.OrderNo=e;
				this.getOrderDel();
    		},
    		async CancelOrder(e) {
    		    await this.$confirm("你是否要取消该条订单数据?", "提示", {
        			width: "300px",
        			confirmButtonText: "确定",
        			cancelButtonText: "取消",
        			type: "warning",
      			});
    		    this.OrderNo=e;
    		    this.getCancelOrder();
    		},
			async ConfirmOrders(e){
				await this.$confirm("你是否确认收到货品?", "提示", {
        			width: "300px",
        			confirmButtonText: "确定",
        			cancelButtonText: "取消",
        			type: "warning",
      			});
    		    this.OrderNo=e;
    		    this.getConfirmOrders();
			},
			async ReturnOrder(){
				await this.$confirm("你是否要退货?", "提示", {
        			width: "300px",
        			confirmButtonText: "确定",
        			cancelButtonText: "取消",
        			type: "warning",
      			});
    		    this.OrderNo=e;
    		    this.getReturnOrder();
			},
			async get_Order() {
        		var res = await this.$post("get_Order",{state: this.state})
        		console.log(res, '获取订单111');
           		this.order_list= res.data.ResultData
				console.log(this.order_list, '获取订单222');
				this.cont = res.data.RowCount
				if(this.order_list.length<10){
					this.hasMoreData = false;
				}
    		},
			async getOrderDel() {
    		    var res = await this.$post("orderDel",{OrderNo: this.OrderNo})
    		    console.log(res, '删除订单');
    		    this.get_Order()
    		},
    		async getCancelOrder(){
    		    var res = await this.$post("CancelOrder",{OrderNo: this.OrderNo})
    		    console.log(res, '取消订单');
    		    this.get_Order()
    		},
    		async getConfirmOrders(){
    		    var res = await this.$post("ConfirmOrders",{OrderNo: this.OrderNo})
    		    console.log(res, '确认收货');
    		    this.get_Order()
    		},
			async getReturnOrder(){
    		    var res = await this.$post("ConfirmOrders",{OrderNo: this.OrderNo})
    		    console.log(res, '退货');
    		    this.get_Order()
    		},
			tobuy(e) {
      			this.$router.push({
        			path: "/buy",
        			query: {
          				OrderNo: e,
        			},
      			});
    		},
			toPwd() {
				this.$router.push("/setPwd")
			},
			toAddress() {
				this.$router.push("/address")
			},
			toOrderList() {
				this.$router.push("/orderList")
			},
			toFast() {
				this.$router.push("/fast")
			},
			toSetPwd() {
				this.$router.push("/setPwd")
			},
			toUserInfo() {
				this.$router.push("/userInfo")
			},
			toCar() {
				this.$router.push("/car")
			}
		}
	}
</script>
<style >
@media (max-width: 992px) {
  .msgbox{
    width: 320px !important;
  }
}
</style>
<style scoped>
.scroll {
	max-height: 500px;
	overflow-y: auto;
}
.order_body {
		background-color: white;
		padding-left: calc(20px/2);
		padding-right: 10px;
		margin: 13px auto;
		color: #333;
	}

	.order_tabs {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
	}

	.order_body_d1 {
		width: 100%;
		height: calc(82px/2);
	}

	.order_body_d1 {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.order_body_d1_l {
		width: 50%;
		line-height: calc(28px/2);
		font-size: calc(28px/2);
		display: flex;
		justify-content: flex-start;
		align-items: center;
		white-space: nowrap;
	}

	.order_body_d1_r {
		width: 50%;
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}

	.order_body_d1_r_d {
		width: calc(60px/2);
		height: calc(50px/2);
		color: #666;
	}

	.order_body_d2 {
		width: 100%;
		height: calc(190px/2);
		display: flex;
		flex-direction: row;
		align-items: center;
		box-sizing: border-box;
		border-top: calc(2px/2) solid #f2f2f2;
		border-bottom: calc(2px/2) solid #f2f2f2;
	}

	.order_body_d2 img {
		width: calc(150px/2);
		height: calc(150px/2);
		border-radius: calc(10px/2);
		margin-right: calc(20px/2)
	}

	.order_body_d2_d1 {
		width: calc(500px/2);
		font-size: calc(30px/2);
		height: calc(150px/2);
		display: flex;
		flex-direction: column;
		text-align: left;
		justify-content: flex-start;
		line-height: calc(54px/2);
	}

	.order_body_d2_d3 {
		font-size: calc(28px/2);
	}

	.order_body_d3 {
		width: 100%;
		height: calc(80px/2);
		display: flex;
		align-items: center;
		font-size: calc(28px/2);
	}

	.order_body_d3_sp1 {
		width: 20%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		color: red;
	}

	.order_body_d3_sp2 {
		width: 80%;
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}

	.order_body_d4 {
		box-sizing: border-box;
		border-top: calc(2px/2) solid #f2f2f2;
		width: 100%;
		height: calc(100px/2);
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}

	.order_body_d4_b {
		margin-left: calc(30px/2);
		height: calc(64px/2);
	}
</style>